<div class="edit-booking-modal">
  <div class="edit-booking-modal__header">
    <h5 class="edit-booking-modal__title">
      <i class="fa-solid fa-edit me-2"></i>
      Edit Bookings
    </h5>
    <button class="edit-booking-modal__close" (click)="closeModal()">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <div class="edit-booking-modal__body">
    <!-- Tab Navigation Arrows -->
    <div class="edit-booking-tab-navigation">
      <button class="edit-booking-tab-nav-btn" (click)="scrollTabsLeft()" [disabled]="!canScrollLeft()"
        [class.disabled]="!canScrollLeft()" title="Scroll Left">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <button class="edit-booking-tab-nav-btn" (click)="scrollTabsRight()" [disabled]="!canScrollRight()"
        [class.disabled]="!canScrollRight()" title="Scroll Right">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>

    <app-my-tabs [tabs]="tabs" [defaultTabIndex]="currentTabIndex" (tabChange)="onTabChange($event)">
      <div tab0>
        <div class="edit-booking-section">
          <h6 class="edit-booking-section__title">
            <i class="fa-solid fa-question-circle me-2"></i>
            Booking Questions
          </h6>

          <div class="edit-booking-questions">
            <div *ngFor="let qn of currentCategoryBookingQuestions; let i = index" class="edit-booking-question-card">
              <div class="edit-booking-question-card__header">
                <span class="edit-booking-question-card__number" *ngIf="!qn.isTag"> Question {{ i + 1 }} </span>
                <button class="edit-booking-question-card__remove" (click)="removeBookingQuestion(i)" *ngIf="!qn.isTag">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>

              <div class="edit-booking-question-card__content" *ngIf="!qn.isTag">
                <div class="form-group">
                  <label class="form-label">Question Text</label>
                  <input type="text" class="form-control" [(ngModel)]="qn.questionText"
                    placeholder="Enter question text" />
                </div>

                <div class="form-group">
                  <label class="form-label">Answer Type</label>
                  <select class="form-control py-0" [(ngModel)]="qn.type">
                    <option value="text">Text Input</option>
                    <option value="multipleChoice">Multiple Choice</option>
                    <option value="singleDate">Single Date</option>
                    <option value="dateRange">Date Range</option>
                  </select>
                </div>

                <button *ngIf="qn.type === 'multipleChoice'" class="btn btn-outline-primary btn-sm"
                  (click)="addChoiceToBookingQuestion(i)">
                  <i class="fa-solid fa-plus me-1"></i>
                  Add Choice
                </button>
              </div>

              <!-- Multiple Choice Options -->
              <div class="edit-booking-choices" *ngIf="qn.type === 'multipleChoice'">
                <div class="edit-booking-choices__list">
                  <div class="edit-booking-choice-item"
                    *ngFor="let choice of qn.choices; let j = index; trackBy: trackByChoice">
                    <input type="text" class="form-control" [(ngModel)]="qn.choices[j]"
                      placeholder="Choice {{ j + 1 }}" />
                    <button class="edit-booking-choice-item__remove" (click)="removeChoiceFromBookingQuestion(i, j)">
                      <i class="fa-solid fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="edit-booking-choices__empty" *ngIf="qn.choices.length === 0">
                  <i class="fa-solid fa-info-circle me-2"></i>
                  No choices yet — please add one.
                </div>
              </div>
            </div>

            <div class="edit-booking-questions__empty" *ngIf="currentCategoryBookingQuestions.length === 0">
              <i class="fa-solid fa-question-circle me-2"></i>
              No questions yet — please add one.
            </div>

            <button class="btn btn-primary" (click)="addNewQuestionToMapBooking()">
              <i class="fa-solid fa-plus me-1"></i>
              Add Question
            </button>
          </div>
        </div>
      </div>
      <div tab1>
        <!-- Tags Section -->
        <div class="edit-booking-section">
          <h6 class="edit-booking-section__title">
            <i class="fa-solid fa-tags me-2"></i>
            Tags
          </h6>

          <div class="edit-booking-tags">
            <div class="edit-booking-tags__list" *ngIf="currentCategoryTagList?.length > 0">
              <div class="edit-booking-tag-item" *ngFor="let tag of currentCategoryTagList; index as i">
                <span class="edit-booking-tag-item__text">{{ tag }}</span>
                <button class="edit-booking-tag-item__remove" (click)="removeBookingTagOptionFromCategory(i)">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>

            <div class="edit-booking-tags__empty" *ngIf="currentCategoryTagList?.length === 0">
              <i class="fa-solid fa-info-circle me-2"></i>
              No tags added yet
            </div>

            <div class="edit-booking-tags__add">
              <div class="input-group">
                <input type="text" [(ngModel)]="newTagText" class="form-control" placeholder="Enter new tag" />
                <button class="btn btn-success" (click)="addNewTag()" [disabled]="!newTagText?.trim()">
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <span class="edit-booking-section__title mt-4"><i class="fa-solid fa-handshake mr-1"></i> Thank You
            Text</span>
          <textarea rows="5" placeholder="Thank you text" class="form-control my-1"
            [(ngModel)]="thankYouText"></textarea>
        </div>
      </div>
      <div tab2>
        <div class="edit-booking-section">
          <h6 class="edit-booking-section__title">
            <i class="fa-solid fa-user-tag me-2"></i>
            Tag Users
          </h6>

          <div class="edit-booking-tagged-users">
            <div class="edit-booking-tags__list" *ngIf="taggedUsers?.length > 0">
              <div class="edit-booking-tag-item" *ngFor="let user of taggedUsers; index as i">
                <span class="edit-booking-tag-item__text">{{ user }}</span>
                <button class="edit-booking-tag-item__remove" (click)="removeTaggedUser(i)">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
            </div>

            <div class="edit-booking-tags__empty" *ngIf="taggedUsers?.length === 0">
              <i class="fa-solid fa-info-circle me-2"></i>
              No users tagged yet
            </div>

            <div class="edit-booking-tags__add">
              <div class="input-group">
                <input type="text" [(ngModel)]="newTaggedUserText" class="form-control" placeholder="Enter user tag" />
                <button class="btn btn-success" (click)="addNewTaggedUser()" [disabled]="!newTaggedUserText?.trim()">
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div tab3>
        <div class="edit-booking-section my-4">
          <span class="edit-booking-section__title mt-4"><i class="fa-solid fa-handshake mr-1"></i> Contact
            Whatsapp</span>
          <input type="text" placeholder="Contact Whatsapp" [(ngModel)]="contactWhatsApp" class="form-control" />
        </div>

        <!-- Booking Image Section -->
        <div class="edit-booking-section">
          <h6 class="edit-booking-section__title">
            <i class="fa-solid fa-image me-2"></i>
            Booking Image
          </h6>

          <div class="edit-booking-image">
            <div class="edit-booking-image__preview">
              @if (currentCategoryBookingImageInfo?.convertedFileUrl) {
              <img (click)="openSelectBookingImage()" [src]="currentCategoryBookingImageInfo?.convertedFileUrl"
                class="edit-booking-image__img" />
              } @else if (currentCategoryBookingImageInfo?.url) {
              <img (click)="openSelectBookingImage()" [src]="imgUrl + currentCategoryBookingImageInfo?.url"
                class="edit-booking-image__img" />
              } @else {
              <div class="edit-booking-image__placeholder" (click)="openSelectBookingImage()">
                <i class="fa-solid fa-cloud-upload-alt"></i>
                <span>Click to upload image</span>
              </div>
              }
            </div>

            <input (change)="setBookingImage($event)" #bookingImageFileSelector type="file" class="d-none"
              accept="image/*" />

            <div class="form-group mt-3">
              <label class="form-label">Image Caption</label>
              <app-editor [(innerValue)]="ckEditorText"></app-editor>
            </div>
          </div>
        </div>
      </div>

      <div tab4>
        <div class="edit-booking-section">
          <h6 class="edit-booking-section__title">
            <i class="fa-solid fa-stairs me-2"></i>
            Steps
          </h6>

          <div class="edit-booking-steps">
            <div *ngFor="let step of bookingSteps; let i = index; trackBy: trackByStep" class="edit-booking-step-card">
              <div class="edit-booking-step-card__header">
                <span class="edit-booking-step-card__number">Step {{ i + 1 }}</span>
              </div>

              <div class="edit-booking-step-card__content">
                <div class="form-group">
                  <label class="form-label">Title</label>
                  <input type="text" class="form-control" [value]="step.title" (keyup)="updateStepTitle(i, $event)"
                    placeholder="Enter step title" />
                </div>

                <div class="form-group">
                  <label class="form-label">Description</label>
                  <textarea class="form-control" rows="3" [value]="step.description"
                    (keyup)="updateStepDescription(i, $event)" placeholder="Enter step description"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-my-tabs>

    <!-- Questions Section -->

    <!-- Tagged Users Section -->
  </div>

  <div class="edit-booking-modal__footer">
    <button class="btn btn-primary" (click)="saveBookingQuestions()">
      <i class="fa-solid fa-save mr-1"></i>
      Save Changes
    </button>
  </div>
</div>